export var transformFormToApiParams = function (data) { return ({
    publisherPrefixId: data.publisherPrefixId,
}); };
